import * as Yup from 'yup';
import { emailRegEx } from '../../../utils/RegularExpressions';

export const validationSchema = Yup.object({
  email: Yup.string()
    .required('Email is required')
    .matches(emailRegEx, 'Invalid Email Address')
    .min(2, 'Contact Person Full Name must be greater than 2 characters'),
});
